<template>
  <router-link :to="to" style="text-decoration: none" target="_blank">
    <slot>
      <v-btn icon class="primary--text">
        <v-icon>mdi-account-edit</v-icon>
      </v-btn>
    </slot>
  </router-link>
</template>

<script>
    export default {
      name: "editProfile",
      props: {
          profileId: String,
          IdTarget: {
            type: String,
            default: null,
            required: false
          }
      },
      computed: {
        getParams(){
          return  {id: this.profileId}
        },
        name(){
          return this.$route.path.indexOf('staff') > -1 ? 'staffEdit' : 'scoutingEdit';
        },
        to(){
          let to = {name: this.name, params: this.getParams}
          if (this.IdTarget){
            to.hash = '#'+this.IdTarget;
          }
          return to;
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Buttons/Profiles/editProfile.vue